import { gsap } from 'gsap'

let bannerTop, bannerBottom = null

function setupBanner()
{
  let $fp_banner = $('.fp-banner')
  if($fp_banner.length) {

    bannerTop = gsap.to(".js-animate-line-element.js-move-left", {xPercent: -100, repeat: -1, duration: 20, ease: "linear"}).totalProgress(0.5);
    gsap.set(".fp-banner-line-inner.js-move-left", {xPercent: -50});

    bannerBottom = gsap.to(".js-animate-line-element.js-move-right", {xPercent: 100, repeat: -1, duration: 18, ease: "linear"}).totalProgress(0.5);
    gsap.set(".fp-banner-line-inner.js-move-right", {xPercent: -150});

  }
}


function playBanner()
{
  if(bannerTop && bannerBottom) {
    bannerTop.play()
    bannerBottom.play()
  }
}

function pauseBanner()
{
  if(bannerTop && bannerBottom) {
    bannerTop.pause()
    bannerBottom.pause()
  }
}

export { playBanner, pauseBanner, setupBanner }
